import { differenceInMinutes } from 'date-fns';

import { CARGO_TYPES, MODE_FCL } from '@/lib/constants';
import { ShipmentCargo, ShipmentModel, ShipmentTrackingDataModel } from '@/lib/models/shipment/types';
import { formatDateStringToIso } from '@/utils/format/date-time';
import { formatVolumeUnit } from '@/utils/format/volume';
import { formatWeightUnit } from '@/utils/format/weight';

export const getShipmentDelay = (trackingData: ShipmentTrackingDataModel, existingShipment: ShipmentModel) => {
  const { originalEta: originalEtaString } = existingShipment;
  const { portToPort } = trackingData.shipmentLegs;
  const currentEtaString = formatDateStringToIso(portToPort?.dischargePortEta || portToPort?.destinationPortEta);

  if (currentEtaString && originalEtaString && currentEtaString !== originalEtaString) {
    const originalEta = new Date(originalEtaString);
    const currentEta = new Date(currentEtaString);
    return differenceInMinutes(currentEta, originalEta);
  }

  return 0;
};

export const getShipmentCargo = (trackingData: ShipmentTrackingDataModel): ShipmentCargo => {
  const {
    shippingMode,
    containerSize,
    containerType,
    containerIso,
    totalWeight,
    totalWeightUom,
    packageType,
    totalNumberOfPackages,
    totalVolume,
    totalVolumeUom,
  } = trackingData;

  const isFCL = shippingMode === MODE_FCL;
  const container = {
    size: containerSize || '',
    type: containerType || '',
    iso: containerIso || '',
  };

  return {
    type: isFCL ? CARGO_TYPES.CONTAINER : CARGO_TYPES.ITEM,
    quantity: 1,
    ...(isFCL ? { container } : {}),
    ...(totalVolume && totalVolumeUom
      ? {
          volume: {
            value: Number(totalVolume),
            unit: formatVolumeUnit(totalVolumeUom),
          },
        }
      : {}),
    ...(totalWeight && totalWeightUom
      ? {
          weight: {
            value: Number(totalWeight),
            unit: formatWeightUnit(totalWeightUom),
          },
        }
      : {}),
    ...(packageType ? { packageType } : {}),
    ...(totalNumberOfPackages ? { packageQuantity: totalNumberOfPackages.toString() } : {}),
  };
};
